import React from 'react'
import CompareWithLmsForm from './CompareWithLmsForm'
import { useParams } from 'react-router'
import {
    useFetchLmsQuestionsQuery,
    useUpdateLmsQuestionsRelationshipsMutation,
} from '../../../../../store/apis/lms.api'
import { Alert, Spin } from 'antd'
import { openNotificationWithIcon } from '../../../../../utils/notification.helper'

const CompareWithLmsFormContainer = () => {
    const { token } = useParams()

    const {
        data: lms,
        isFetching: isFetchingLmsQuestions,
        error: fetchingLmsQuestionsError,
    } = useFetchLmsQuestionsQuery({ assignmentToken: token })

    const [updateLmsQuestionsRelationships, updateLmsQuestionsRelationshipsResult] =
        useUpdateLmsQuestionsRelationshipsMutation()

    const isFetching = isFetchingLmsQuestions
    const error = fetchingLmsQuestionsError

    const handleSubmit = async questionsRelationships => {
        const response = await updateLmsQuestionsRelationships({ assignmentToken: token, questionsRelationships })
        if ('data' in response) openNotificationWithIcon('success', 'LMS questions relationships updated successfully')
    }

    return (
        <Spin spinning={isFetching} tip='Loading...'>
            {error ? (
                <Alert message={error} type='error' showIcon closable />
            ) : (
                <CompareWithLmsForm
                    questions={lms?.questionsEnrichedWithLms || []}
                    lmsQuestions={lms?.lmsQuestions || []}
                    onSubmit={handleSubmit}
                    loading={updateLmsQuestionsRelationshipsResult.isLoading}
                    error={updateLmsQuestionsRelationshipsResult.error}
                />
            )}
        </Spin>
    )
}

export default CompareWithLmsFormContainer
